import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import ProductItem from '../Common/ProductItem';

const FlashDeals = () => {
    const products = useSelector((store) => store.products.data);

    if (!products || products.length === 0) {
        return (
            <div className="d-flex justify-content-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <StyledFlashDeals>
            <div className="flash-grid">
                {products.map((product) => (
                    <div key={product.id} className="flash-grid-item">
                        <ProductItem product={product} />
                    </div>
                ))}
            </div>
        </StyledFlashDeals>
    );
};

export default FlashDeals;

const StyledFlashDeals = styled.div`
    width: 100%;

    .flash-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 20px;
    }

    @media (max-width: 991px) {
        .flash-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 16px;
        }
    }

    @media (max-width: 575px) {
        .flash-grid {
            grid-template-columns: 1fr;
            gap: 14px;
        }
    }
`;
